import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

import { SnCamera } from '@lib/api/entities';

@Injectable({
  providedIn: 'root',
})
export class PursuitService {
  public selectedTime: Date;

  private readonly _camera$: Subject<SnCamera> = new Subject();
  private readonly _snapAi$: Subject<any> = new Subject();
  private readonly _detectionType$: Subject<string> = new Subject();
  private readonly _hoverMap$: Subject<string> = new Subject();
  private readonly _hoverRadar$: Subject<string> = new Subject();
  private readonly _hoverRoute$: Subject<SnCamera[]> = new Subject();
  private readonly _leaveMap$: Subject<string> = new Subject();
  private readonly _leaveRadar$: Subject<string> = new Subject();
  private readonly _leaveRoute$: Subject<boolean> = new Subject();
  private readonly _screenshot$: Subject<boolean> = new Subject();
  private readonly _timeEst$: Subject<boolean> = new Subject();
  private readonly _newCam$: Subject<any> = new Subject();
  private readonly _cameraMarkerChange$: Subject<any> = new Subject();

  private timeEstimates: boolean = true;
  private isPursuit: boolean = false;
  private prevCams: SnCamera;

  constructor() {}

  get cameraMarkerChange$(): Observable<any> {
    return this._cameraMarkerChange$.asObservable();
  }

  public isTimeToggled(): boolean {
    return this.timeEstimates;
  }

  public timeToggle(): void {
    this.timeEstimates = !this.timeEstimates;
    this._timeEst$.next(this.timeEstimates);
  }

  public getTimeToggle(): Observable<boolean> {
    return this._timeEst$.asObservable();
  }

  public togglePursuit(value: boolean): void {
    this.isPursuit = value;
  }

  public getPursuit(): Observable<SnCamera> {
    return this._camera$.asObservable();
  }

  public setPursuit(camera: SnCamera): void {
    this._camera$.next(camera);
    this.isPursuit = camera ? true : false;
  }

  public getSnapAi(): Observable<any> {
    return this._snapAi$.asObservable();
  }

  public setScreenshot(value: boolean): void {
    this._screenshot$.next(value);
  }

  public getScreenshot(): Observable<boolean> {
    return this._screenshot$.asObservable();
  }

  public setDetectionType(detectionType: string): void {
    this._detectionType$.next(detectionType);
  }

  public getDetectionType(): Observable<string> {
    return this._detectionType$.asObservable();
  }

  public setSnapAi(snapAi: any): void {
    this._snapAi$.next(snapAi);
    this.isPursuit = snapAi ? true : false;
  }

  public getHoverMap(): Observable<string> {
    return this._hoverMap$.asObservable();
  }

  public getHoverRadar(): Observable<string> {
    return this._hoverRadar$.asObservable();
  }

  public getLeaveRadar(): Observable<string> {
    return this._leaveRadar$.asObservable();
  }

  public getHoverRoute(): Observable<SnCamera[]> {
    return this._hoverRoute$.asObservable();
  }

  public getLeaveRoute(): Observable<boolean> {
    return this._leaveRoute$.asObservable();
  }

  public getLeaveMap(): Observable<string> {
    return this._leaveMap$.asObservable();
  }

  public getNewCam(): Observable<any> {
    return this._newCam$.asObservable();
  }

  public setNewCam(cam: string, time?: any): void {
    const date = new Date(`${time}`);
    const camObj = {
      cam,
      time: date,
    };
    this._newCam$.next(camObj);
  }

  public leaveRadar(id: string): void {
    this._leaveRadar$.next(id);
  }

  public leaveMap(id: string): void {
    this._leaveMap$.next(id);
  }

  public hoverMap(id: string): void {
    this._hoverMap$.next(id);
  }

  public hoverRadar(id: string): void {
    this._hoverRadar$.next(id);
  }

  public leaveRoute(value: boolean): void {
    this._leaveRoute$.next(value);
  }

  public hoverRoute(start: SnCamera, end: SnCamera): void {
    const camArray: SnCamera[] = [start, end];
    this._hoverRoute$.next(camArray);
  }

  public getPursuitValue(): boolean {
    return this.isPursuit;
  }

  public getPrevCams(): SnCamera {
    return this.prevCams;
  }

  public setPrevCams(cams: SnCamera): void {
    this.prevCams = cams;
  }

  public onCameraMarkerChange(): void {
    this._cameraMarkerChange$.next();
  }
}
